import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { InputLabel, PTable } from './styles';
import IndentedDropdown from '../../../components/IndentedDropdown/IndentedDropdown';
import InputField from '../../../components/InputField/InputField';
import Button from '../../../components/Button/Button';
import ButtonSecondary from '../../../components/Button/ButtonSecondary';
import { getLots, getProducts, getStockMovementReport } from '../../../api';

const StockMovement = () => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [products, setProducts] = useState([]);
  const [lots, setLots] = useState([]);
  const [product, setProduct] = useState(-1);
  const [lot, setLot] = useState(0);
  const [tableData, setTableData] = useState([]);

  const productSelected = (e) => {
    setProduct(e.value);
  };

  const lotSelected = (e) => {
    setLot(e.value);
  };

  useEffect(() => {
    getProducts().then(({ data }) => {
      const productToSelect = [];
      productToSelect.push(
        ...data.map((product) => {
          return {
            value: product.id,
            label: product.name
          };
        })
      );
      setProducts(productToSelect);
    });

    getLots().then(({ data }) => {
      const lotToSelect = [{ label: 'All', value: 0 }];
      lotToSelect.push(
        ...data.map((lot) => {
          return {
            value: lot.id,
            label: lot.ref_desc
          };
        })
      );
      setLots(lotToSelect);
    });
  }, []);

  const getReport = async (download) => {
    if (!fromDate) {
      alert('Please select a date to report from');
      return;
    }

    if (!toDate) {
      alert('Please select a date to report to');
      return;
    }

    if (product < 0) {
      alert('Please select a product');
      return;
    }

    const { data } = await getStockMovementReport(
      fromDate,
      toDate,
      product,
      lot,
      download
    );
    if (download) {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute(
        'download',
        `Stock Movement Report ${fromDate}-${toDate}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      setTableData(data.data);
      if (data.data.length == 0) {
        alert('No results');
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: '#f5f5f5',
          padding: '10px 0'
        }}
      >
        <InputLabel>
          <label>From Date</label>
          <InputField
            type='date'
            placeholder='Start Date'
            customStyle={{ minWidth: 250 }}
            onChange={(val) => setFromDate(val.target.value)}
          />
        </InputLabel>
        <InputLabel>
          <label>To Date</label>
          <InputField
            type='date'
            customStyle={{ minWidth: 250 }}
            onChange={(val) => setToDate(val.target.value)}
          />
        </InputLabel>
        <InputLabel>
          <label>Product</label>
          <Select
            options={products}
            placeholder='Search'
            onChange={productSelected}
            styles={{
              control: (styles) => ({
                ...styles,
                minWidth: 250,
                border: 'none',
                borderRadius: 8,
                padding: 2,
                border: '1px solid #E4E4E4'
              })
            }}
          />
        </InputLabel>
        <InputLabel>
          <label>Lot (Optional)</label>
          <Select
            options={lots}
            placeholder='Search'
            onChange={lotSelected}
            styles={{
              control: (styles) => ({
                ...styles,
                minWidth: 250,
                border: 'none',
                borderRadius: 8,
                padding: 2,
                border: '1px solid #E4E4E4'
              })
            }}
          />
        </InputLabel>
      </div>
      <div className='action-buttons'>
        <Button
          title='Generate'
          onClick={() => getReport()}
          disabled={!fromDate || !toDate || product < 0}
        />
        <ButtonSecondary
          title='Download .csv'
          onClick={() => getReport(true)}
          disabled={!fromDate || !toDate || product < 0}
        />
      </div>

      <PTable>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Transaction</th>
              <th>Document</th>
              <th>User</th>
              <th>Party</th>
              <th>Site</th>
              <th>Product</th>
              <th>Lot</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => {
              return (
                <tr>
                  <td>{row.Date}</td>
                  <td>{row.Transaction}</td>
                  <td>{row.Document}</td>
                  <td>{row.User}</td>
                  <td>{row.Party}</td>
                  <td>{row.Site}</td>
                  <td>{row.Product}</td>
                  <td>{row.Lot}</td>
                  <td>{row.Quantity}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </PTable>
    </>
  );
};

export default StockMovement;
